// app/frontend/controllers/index.js
import { Application } from "@hotwired/stimulus";

const application = Application.start();

// Automatically load all controllers in this directory and subdirectories
// Controllers should be named *_controller.js
const controllers = import.meta.glob("./**/*_controller.js", { eager: true });

// Track registered controllers to prevent duplicates
const registeredControllers = new Set();

for (const path in controllers) {
  const module = controllers[path];
  // Get the controller name from the file path
  // e.g., "./hello_controller.js" -> "hello"
  // e.g., "./nested/example_controller.js" -> "nested--example"
  const controllerName = path
    .replace("./", "")
    .replace("_controller.js", "")
    .replace(/\//g, "--") // Convert slashes to double dashes for nested controllers
    .replace(/_/g, "-"); // Convert underscores to hyphens for multi-word controllers

  // Only register if not already registered (prevents duplicates on hot reload)
  if (module.default && !registeredControllers.has(controllerName)) {
    application.register(controllerName, module.default);
    registeredControllers.add(controllerName);
  }
}

